<div>
  A new user signed up using the email address “{{ email }}” the link you created at {{ time }} on {{ date }}.<br>
  {{ userNameMsg }}.
  <br><br>
  You can now control this user’s access rights on the User Access page.<br>
  If you don’t recognise this email address or username, please contact the ManageIt team.
</div>
